import moment from 'moment'
import Formsy,  { addValidationRule } from 'formsy-react'
import React, { Component } from 'react'
import { Button, Confirm, Grid, Message, Icon ,Segment, Table, Header, Dropdown, Container, Pagination, Search, Dimmer, Loader  } from 'semantic-ui-react'
import { extendTrialSubscription, getMarkets } from 'services/Manager'
import { cancelSubscription, endTrial } from '../../services/payment'
import { getTrialSubscription, searchTrialSellers } from '../../services/SellerSubscription'
import './TrialSubscriptions.less'
import { getCategoryList } from 'services/Categories'
import info_icon_new from '../../assets/images/newui/newrequestpage/info-icon.svg'
import DGTextbox from 'components/FormControls/Textbox/DGTextbox';
import { updateSellerEmail , sendTestEmailToTrialSeller} from 'services/Seller';
import { verifyEmail } from 'services/User';
import { isValidEmail} from 'helpers/validation';
import ErrorBox from 'components/ErrorBox/ErrorBox'
import { NotificationContainer, NotificationManager } from 'react-notifications';
import SellerInfoModal from 'components/SellerInfoModal/SellerInfoModal'

const rowsPerPage = 20;
const noticationTimeout = 1000;

addValidationRule('isValidEmail', isValidEmail);

class TrialSubscriptions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            subscriptions: [],
            isSuccessMessageShown: false,
            selectedSubscriptionID: null,
            isConfirmModalOpen: false,
            markets: [],
            currentMarketValue: '',
            currentMarketText: '',
            categories: [],
            currentCategoryValue: '',
            currentCategoryText: '',
            page: 1,
            selectedSubscriptionIDForTrialEnd: null,
            isEndTrialButtonDisabled: false,
            isConfirmTrialEndModalOpen: false,
            sellerInfoModalOpen: false,
            infoSelectedSeller:{},
            trialSellerList: [],
            searchTerm: '',
            trialSellerID: 0,
            trialSellerName: '',
            sellerEmailEditId:undefined,
            sellerEmailEditSubId:undefined,
            sellerEmailEditErrorMsg:"",
            testEmailButtonDisabled:false,
            showTrialExtensionConfirmation: false,
            trialExtensionConfirmationMessage: '',
            trialExtensionSellerSubID: 0,
            trialExtensionSellerID: 0,
            trialExtensionDays: 0,
            extendingTrial: false,
            changingPage: false
        }

        this.searchSellerTimer = null;
        this.sellerEmailformRef = React.createRef();
    }

    componentDidMount() {

        const categoryPromise = getCategoryList();
        const marketPromise = getMarkets();

        Promise.all([categoryPromise, marketPromise]).then(([categoryRes, marketRes]) => {
            const categoryList = this.populateCategories(categoryRes.data);
            const marketList = this.populateMarkets(marketRes.data);

            this.setState(
                {
                    markets: marketList,
                    currentMarketText: 'Any Market',
                    currentMarketValue: '',
                    categories: categoryList,
                    currentCategoryText: 'All Categories',
                    currentCategoryValue: '',
                }, () => {
                    this.onSearch();
                }
            );

        });
    }

    populateCategories = (categories) => {
        let categoryList = _.map(categories, cat => {
            return { value: cat.seoName, text: cat.name }
        });

        categoryList = [{ value: '', text: 'All Categories' }, ...categoryList];
        return categoryList;
    }

    onSearch = (e, data) => {
        getTrialSubscription(this.state.page, rowsPerPage, this.state.currentCategoryValue, this.state.currentMarketValue, this.state.trialSellerID).then(res => {
            this.setState({ subscriptions: res.data.trialSubscriptionList || [], subscriptionListCount: res.data.count || 0 });

        })
    }

    populateMarkets = (markets) => {
        let marketList = _.map(markets, market => {
            return { value: market.marketID, text: market.name }
        });

        marketList = [{ value: '', text: 'Any Market' }, ...marketList];
        return marketList;
    }

    onMarketChange = (e, data) => {
        const selectedMarket = _.first(_.filter(this.state.markets, item => item.value == data.value));
        this.setState({ currentMarketValue: selectedMarket.value, currentMarketText: selectedMarket.text })
    }

    onCategoryChange = (e, data) => {
        const selectedCategory = _.first(_.filter(this.state.categories, item => item.value == data.value));
        this.setState({ currentCategoryValue: selectedCategory.value, currentCategoryText: selectedCategory.text })
    }

    onCancelSubscription = () => {
        cancelSubscription({
            subscriptionID: this.state.selectedSubscriptionID,
            cancelNow: true,
            cancelAllPlanPayments: true
        }).then(res => {
            if (res.resStatus) {
                this.showSuccessMessage();
                this.setState({
                    isConfirmModalOpen: false,
                    selectedSubscriptionID: null
                }, () => {
                    this.onSearch();
                })

            }
        })
    }

    onPageChange = (e, data) => {
        this.setState({ page: data.activePage, changingPage: true }, () => {
            this.onSearch();
            this.setState({changingPage: false})    
        });
    }

    onEndTrial = () => {
        this.setState({ isEndTrialButtonDisabled: true })
        endTrial(this.state.selectedSubscriptionIDForTrialEnd).then(res => {
            if (res.resStatus == 200) {
                this.showSuccessMessage();
                this.setState({
                    isConfirmTrialEndModalOpen: false,
                    selectedSubscriptionID: null
                })
                getTrialSubscription().then(res => {
                    this.setState({ subscriptions: res.data })
                });
            }
        }).finally(() => {
            this.setState({ isEndTrialButtonDisabled: false })
        })
    }

    showSuccessMessage = () => {
        this.setState({ isSuccessMessageShown: true });
        setTimeout(() => {
            this.setState({ isSuccessMessageShown: false });
        }, 4000);
    }

    onSubscriptionSelect = (sub) => {
        this.setState({
            selectedSubscriptionID: sub.sellerSubID,
            isConfirmModalOpen: true
        })
    }


    onSubscriptionSelectForEndTrial = (sub) => {
        this.setState({
            selectedSubscriptionIDForTrialEnd: sub.sellerSubID,
            isConfirmTrialEndModalOpen: true
        })
    }

    onShowSellerInfoModal = (seller) => {
        this.setState({
            infoSelectedSeller: seller,
            reloadSellers: false,
            sellerInfoModalOpen: true,
        });
    }

    onSellerInfoModalClose = () => {
        this.setState({
            sellerInfoModalOpen: false
        })
    }

    handleSellerInfoSave = () => {
        this.onSearch();
    }

    onSearchSellerChange = (e, data) => {
        this.setState({trialSellerName: data.value})
        if(this.searchSellerTimer){
            clearTimeout(this.searchSellerTimer);
        }

        this.setState({searchTerm: data.value});

        this.searchSellerTimer = setTimeout(async () => {
            const res = await searchTrialSellers(this.state.searchTerm);
            if(res.resStatus == 200){
                const sellers = res.data;
                const sellerList = _.map(sellers, s => {
                    return {title: s.name, id: s.sellerID}
                });

                this.setState({trialSellerList: sellerList})
                
            }
        }, 600);
    }

    onSellerSelect = (e, data) => {
        this.setState({trialSellerID: data.result.id, trialSellerName: data.result.title});
    }
    
    resetSearch = () => {
        this.setState({trialSellerID: 0, trialSellerName: ''})
    }

    handleSellerEmailEditClick = (sellerID , sellerSubID) => {
        this.setState({ sellerEmailEditId : sellerID,  sellerEmailEditSubId : sellerSubID})
    }

    handleSellerEmailCancelClick = () => {
        this.setState({ sellerEmailEditId : undefined,  sellerEmailEditSubId : undefined})
    }

    sellerEmailEditFormValidSubmit = async (emailEditForm, sellerID, orignalEmail) => {
        if (emailEditForm.sellerEmail != orignalEmail) {

            const verifyEmailRes = await verifyEmail(emailEditForm.sellerEmail);
            if (verifyEmailRes.resStatus == 200) {
                const saveResponse = await updateSellerEmail(sellerID, emailEditForm.sellerEmail);
                if (saveResponse.resStatus == 200) {
                    this.handleSellerEmailCancelClick();
                    this.onSearch();
                }
                else {
                    this.setState({ sellerEmailEditErrorMsg: saveResponse.message })
                }
            }
            else {
                this.setState({ sellerEmailEditErrorMsg: verifyEmailRes.message })
            }
        } else {
            this.handleSellerEmailCancelClick();
        }
    }

    handleTestEmailClick = async (sellerID) => {
        this.setState({ testEmailButtonDisabled: true })
        setTimeout(async () => {
            const res = await sendTestEmailToTrialSeller(sellerID);
            if (res.resStatus == 200) {
                NotificationManager.success("Test email sent successfully.", '', noticationTimeout);
            }
            else {

                NotificationManager.error("Test email not sent.", '', noticationTimeout);
            }
            this.setState({ testEmailButtonDisabled: false })
        }, 100);
    }

    onTrialExtension = (sellerID, sellerSubID, sellerName, days) => {
        const msg = `Do you want to extend "${sellerName}'s" trial for ${days} more days?`;
        this.setState({
            trialExtensionConfirmationMessage: msg, 
            showTrialExtensionConfirmation: true, 
            trialExtensionSellerSubID: sellerSubID, 
            trialExtensionSellerID: sellerID,
            trialExtensionDays: days
        });
    }

    handleCancelTrialExtension = () => {
        this.setState({
            trialExtensionConfirmationMessage: '', 
            showTrialExtensionConfirmation: false, 
            trialExtensionSellerSubID: 0, 
            trialExtensionSellerID: 0,
            trialExtensionDays: 0
        });
    }

    handleConfirmTrialExtension = () => {
        this.setState({extendingTrial: true, showTrialExtensionConfirmation: false}, async () => {
            const res = await extendTrialSubscription(this.state.trialExtensionSellerID, this.state.trialExtensionSellerSubID, this.state.trialExtensionDays);
            if(res.resStatus == 200){
                this.setState({
                    trialExtensionConfirmationMessage: '', 
                    showTrialExtensionConfirmation: false, 
                    trialExtensionSellerSubID: 0, 
                    trialExtensionSellerID: 0,
                    trialExtensionDays: 0,
                    extendingTrial: false
                });
                this.onSearch();
            }
        });
        
    }

    render() {
        return (
            <>
            <NotificationContainer />
            <Dimmer.Dimmable as="div" fluid className='subscription-container' dimmed={this.state.extendingTrial}>
                <Dimmer active={this.state.extendingTrial}>
                    {/*<Loader>Loading</Loader>*/}
                </Dimmer>
            {/*<div className='subscription-container'>*/}
                <div className='subscription-top-heading'>Trial Subscriptions</div>
                {this.state.isSuccessMessageShown ?
                    <Grid.Row>
                        <Grid.Column width={16}><Message positive>
                            <p>Operation completed Successfully!</p>
                        </Message>  </Grid.Column>
                    </Grid.Row> : ''}
                <Segment className="filter-segment">
                    <Formsy onValidSubmit={this.onSearch}>
                        <Grid>
                            <Grid.Row>
                            
                                <Grid.Column width={16} className="search-container">
                                <Header>Search Seller</Header>
                                    <Search fluid className='search' minCharacters={1} onSearchChange={this.onSearchSellerChange}
                                    results={this.state.trialSellerList} onResultSelect={this.onSellerSelect} value={this.state.trialSellerName}  />
                                    <Icon name='delete' onClick={this.resetSearch} />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    <Header>Categories</Header>
                                    <Dropdown fluid name="category" key="act-sub-fil-category"
                                        selection
                                        options={this.state.categories}
                                        value={this.state.currentCategoryValue}
                                        text={this.state.currentCategoryText}
                                        onChange={this.onCategoryChange}
                                    ></Dropdown>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    <Header>Markets</Header>
                                    <Dropdown fluid name="markets" key="act-sub-fil-markets"
                                        selection
                                        options={this.state.markets}
                                        value={this.state.currentMarketValue}
                                        text={this.state.currentMarketText}
                                        onChange={this.onMarketChange}></Dropdown>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    <button className="button-submit">Search</button>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Formsy>
                </Segment>

                <Dimmer.Dimmable as={Segment} className="table-segment" dimmed={this.state.changingPage} >
                    <Dimmer active={this.state.changingPage} />
                    <Loader active={this.state.changingPage}></Loader>
                    {this.state.subscriptions.length ? <Table celled striped>
                        
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Contact</Table.HeaderCell>                               
                                <Table.HeaderCell>Seller Name</Table.HeaderCell>
                                <Table.HeaderCell>Seller Email</Table.HeaderCell>
                                <Table.HeaderCell>Cell Phone</Table.HeaderCell>
                                <Table.HeaderCell>Subscription</Table.HeaderCell>
                                {/* <Table.HeaderCell>Revenue</Table.HeaderCell> */}
                                <Table.HeaderCell>Job Count</Table.HeaderCell>
                                <Table.HeaderCell>Saas Usage Since Trial Start</Table.HeaderCell> 
                                <Table.HeaderCell>Trial Start</Table.HeaderCell>
                                <Table.HeaderCell>Trial End</Table.HeaderCell>
                                <Table.HeaderCell>Days on Trial</Table.HeaderCell>
                                <Table.HeaderCell>Accepting Jobs</Table.HeaderCell>
                                <Table.HeaderCell>Accepting Jobs Last Updated On</Table.HeaderCell>
                                <Table.HeaderCell>Additional Info</Table.HeaderCell>
                                <Table.HeaderCell>Extend Trial</Table.HeaderCell>
                                <Table.HeaderCell></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {this.state.subscriptions.map(s => <Table.Row>
                                <Table.Cell>{s.firstName}</Table.Cell>                               
                                <Table.Cell>{s.sellerName}</Table.Cell>
                                <Table.Cell className={"email"}>
                                    {
                                        this.state.sellerEmailEditId == s.sellerID && this.state.sellerEmailEditSubId == s.sellerSubID ?
                                            <div className={"seller-email-edit-container"}>
                                                <Formsy key={"seller-email-key-"+s.sellerID} ref={this.sellerEmailformRef}  onValidSubmit={(form) => this.sellerEmailEditFormValidSubmit(form , s.sellerID , s.sellerEmail)}>
                                                    <DGTextbox name="sellerEmail" label="Email" placeholder=""
                                                        required type="text"
                                                        tabIndex={3}
                                                        innerRef={(c) => {
                                                            this.emailRef = c;
                                                        }}
                                                        maxLength={100}
                                                        validations={{
                                                            isValidEmail: true,
                                                            maxLength: 100
                                                        }}
                                                        validationErrors={{
                                                            isDefaultRequiredValue: 'This field is required',
                                                            maxLength: 'Email should not exceed 100 characters.',
                                                            isValidEmail: 'Enter a valid email.'
                                                        }}
                                                        onChange={() => this.setState({ sellerEmailEditErrorMsg: '' })}
                                                        value={s.sellerEmail}
                                                    />
                                                    <div className={`seller-edit-icons-container`}>
                                                        <div data-tooltip="Save" data-position="top center" data-inverted="" 
                                                        className={`save-icon-container disableds`}
                                                        onClick={ () => this.sellerEmailformRef.current.submit()}
                                                        > 
                                                            <svg className="save-icon" xmlns="http://www.w3.org/2000/svg" width="22.137" height="15.309" viewBox="0 0 22.137 15.309">
                                                                <path id="Path_29165" data-name="Path 29165" d="M735.7,189.278c1.225-.97,2.413-1.916,3.606-2.854q3.56-2.8,7.126-5.591c.538-.422,1.069-.853,1.614-1.266a1.553,1.553,0,0,1,1.314-.367,1.076,1.076,0,0,1,.772,1.562,2.625,2.625,0,0,1-.51.706q-6.171,6.174-12.355,12.335a2.132,2.132,0,0,1-3.1.011q-2.727-2.7-5.433-5.424a2.139,2.139,0,0,1-.048-2.961,2.115,2.115,0,0,1,2.974-.157c.882.811,1.712,1.68,2.562,2.525C734.711,188.285,735.2,188.777,735.7,189.278Z" transform="translate(-728.113 -179.168)" fill="#7ac943" />
                                                            </svg>
                                                        </div>
                                                        <div data-tooltip="Cancel" data-position="top center" data-inverted="" className={`cancel-icon-container`}
                                                        onClick={() => this.handleSellerEmailCancelClick()} >
                                                            <svg className="cancel-icon" xmlns="http://www.w3.org/2000/svg" width="14.085" height="14.085" viewBox="0 0 14.085 14.085">
                                                                <g id="Group_15496" data-name="Group 15496" transform="translate(0.5 0.585)">
                                                                    <path id="Close-2" data-name="Close" d="M.263,12.738a.9.9,0,0,0,1.269,0L6.5,7.769l4.969,4.969a.9.9,0,0,0,1.269-1.269L7.769,6.5l4.969-4.969A.9.9,0,1,0,11.469.263L6.5,5.231,1.532.263A.9.9,0,0,0,.263,1.532L5.231,6.5.263,11.469A.9.9,0,0,0,.263,12.738Z" transform="translate(0 0)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                                                </g>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </Formsy>
                                                {
                                                    this.state.sellerEmailEditErrorMsg.length ?
                                                        <ErrorBox message={this.state.sellerEmailEditErrorMsg} />
                                                        : ""
                                                }
                                            </div>      
                                            : 
                                            <>
                                            <span className={`seller-email-display `} onClick={ () => this.handleSellerEmailEditClick( s.sellerID ,  s.sellerSubID)}>
                                                {s.sellerEmail}
                                            </span>      
                                            <Button color={"instagram"} disabled={this.state.testEmailButtonDisabled} className={"test-email-button"} onClick={() => this.handleTestEmailClick( s.sellerID )} >Test Email</Button>  
                                            </>   
                                            }

                                            
                                    </Table.Cell>
                                <Table.Cell className={"cell-phone"}>{s.cellPhone}</Table.Cell>
                                <Table.Cell>{s.sellerPlanName} - {s.categoryName}</Table.Cell>
                                {/* <Table.Cell>${s.revenue || '0'}</Table.Cell> */}
                                <Table.Cell>{s.jobCount || '0'}</Table.Cell>
                                <Table.Cell>{s.saasJobCount || '0'}</Table.Cell>
                                <Table.Cell>{moment(s.trialStart).format('LLL')}</Table.Cell>
                                <Table.Cell>{moment(s.trialEnd).format('LLL')}</Table.Cell>
                                <Table.Cell>{moment().diff(moment(s.trialStart), 'days')}</Table.Cell>
                                <Table.Cell>{s.acceptingJobs ? 'Yes' : 'No'}</Table.Cell>
                                <Table.Cell>{s.acceptingJobsLastUpdatedOn? moment(s.acceptingJobsLastUpdatedOn).format('DD MMM YYYY hh:mm A') : '-'}</Table.Cell>
                                <Table.Cell className={"additional-info-cell"}>
                                    <div className={"additional-info-cell-container"}>
                                        <div className={"additional-info-cell-container-text"}>
                                            {s.additionalInfo}
                                        </div>
                                        <div className={"additional-info-cell-container-icon"}>
                                            <img onClick={() => this.onShowSellerInfoModal({ ...s, name: s.sellerName })}
                                                src={info_icon_new}></img>
                                        </div>
                                    </div>
                                </Table.Cell>
                                <Table.Cell className={"buttons-cell"}>
                                    <div className='trial-extension-container'>
                                        <div className='three' onClick={() => this.onTrialExtension(s.sellerID, s.sellerSubID, s.sellerName, 3)}>3 Days</div>
                                        <div className='seven' onClick={() => this.onTrialExtension(s.sellerID, s.sellerSubID, s.sellerName, 7)}>7 Days</div>
                                        <div className='ten' onClick={() => this.onTrialExtension(s.sellerID, s.sellerSubID, s.sellerName, 10)}>10 Days</div>
                                    </div>
                                    
                                </Table.Cell>
                                <Table.Cell className={"buttons-cell"}>
                                    <Button className={"cancel-sub"} onClick={() => this.onSubscriptionSelect(s)} positive>Cancel Subscription</Button>
                                    {/* <Button className={"end-trial"} disabled={this.state.isEndTrialButtonDisabled} onClick={() => this.onSubscriptionSelectForEndTrial(s)} >End Trial</Button> */}
                                    </Table.Cell>
                                
                            </Table.Row>)}
                        </Table.Body>
                    </Table> : <div className='subscription-no-result'>No Trial subscriptions found!</div>}
                    <Container fluid>
                        {this.state.subscriptionListCount > rowsPerPage &&
                            <Pagination ellipsisItem={null} totalPages={Math.ceil(this.state.subscriptionListCount / rowsPerPage)} activePage={this.state.page} onPageChange={this.onPageChange} />
                        }
                    </Container>
                </Dimmer.Dimmable>
                    <Confirm
                        open={this.state.isConfirmModalOpen}
                        onClose={() => this.setState({ isConfirmModalOpen: false })}
                        header='Subscription Cancellation'
                        content='Are you sure you want to cancel selected subscription?'
                        onCancel={() => this.setState({ isConfirmModalOpen: false })}
                        onConfirm={this.onCancelSubscription}
                        className='subscription-cancel-confirm'
                    />

                    <Confirm
                        open={this.state.isConfirmTrialEndModalOpen}
                        onClose={() => this.setState({ isConfirmTrialEndModalOpen: false })}
                        header='End Trial'
                        content='Are you sure you want to end trial?'
                        onCancel={() => this.setState({ isConfirmTrialEndModalOpen: false })}
                        onConfirm={this.onEndTrial}
                        className='subscription-cancel-confirm'
                    />

                    <SellerInfoModal
                        open={this.state.sellerInfoModalOpen}
                        onClose={this.onSellerInfoModalClose}
                        seller={this.state.infoSelectedSeller}
                        onSuccessfullSubmit={this.handleSellerInfoSave}
                    > </SellerInfoModal>
            {/*</div>*/}
            </Dimmer.Dimmable>
            <Confirm
                className='trial-extension-modal'
                open={this.state.showTrialExtensionConfirmation}
                content={this.state.trialExtensionConfirmationMessage}
                onCancel={this.handleCancelTrialExtension}
                onConfirm={this.handleConfirmTrialExtension}
                cancelButton='No'
                confirmButton="Yes"
            />
            </>
        )
    }
}

export default TrialSubscriptions;